import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable, from, of, throwError } from 'rxjs';
import { catchError, map, mergeMap, switchMap, tap } from 'rxjs/operators';
import { EncryptionService } from './encryption.service';
import { ApiCommunicationService } from './api-communication.service';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { API_ENDPOINT, Constants } from '../app-level-constants';

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {
  constants = Constants;
  endpoints = API_ENDPOINT;
  constructor(
    private encryptionService: EncryptionService,
    private apiService: ApiCommunicationService,
    private readonly router: Router,
    private readonly messageService: MessageService
  ) {}

  endpoints_all: string[] = [
    this.endpoints.FETCH_CHECKLIST,
    this.endpoints.GET_CORE_DETAILS,
    this.endpoints.UPLOAD_UPDATE_IMAGES,
    this.endpoints.SAVE_EMAIL,
    this.endpoints.UPDATE_SERIAL_NUMBER,
    this.endpoints.UPLOAD_EXCEL,
    this.endpoints.SAVE_BILLING_EXCEL,
    this.endpoints.MAPPIND_EXCEL,
    this.endpoints.SAVE_GR_EXCEL,
    this.endpoints.SAVE_DEBIT_EXCEL,
    this.endpoints.SAVE_GR_ACK_EXCEL,
  ];

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const loginTimeStr = localStorage.getItem('login_time');
    if (loginTimeStr) {
      const loginTime = parseInt(loginTimeStr, 10);
      const now = Date.now();
      const session_limit = 2 * 60 * 60 * 1000;
      if (now - loginTime > session_limit) {
        localStorage.clear();
        this.router.navigate(['/login']);
        return throwError(() => new Error('Session expired. Please login again.'));
      }
    }
    if (
      req.url.includes('api/reporting-service/twofactorauth/register_user/') ||
      req.url.includes('api/reporting-service/twofactorauth/verify-totp/') ||
      req.url.includes('api/reporting-service/twofactorauth/registertwoFA/')
    ) {
      const creds = this.apiService.getCredentials();
      const extraPayload = req.url.includes('/api/reporting-service/twofactorauth/verify-totp/')
        ? { ...req.body, salt: creds.salt }
        : { ...req.body };

      // return from(this.encryptionService.encryptionMFA(extraPayload)).pipe(
      //   switchMap(encryptedResult => {
      //     const updatedBody = { encrypted_data: encryptedResult };
      //     const clonedReq = req.clone({ body: updatedBody });

      //     return next.handle(clonedReq).pipe(
      //       mergeMap((event: HttpEvent<any>) => {
      //         if (event instanceof HttpResponse && event.body?.enc) {
      //           return from(this.encryptionService.decryptMessage(event.body.enc)).pipe(
      //             map(decrypted => {
      //               const decrypt2 = JSON.parse(decrypted);
      //               if (decrypt2) {
      //                 this.apiService.setCredsLogin(decrypt2.salt);
      //               }
      //               return event.clone({
      //                 body: { verified: decrypt2.verified, twofa_enabled: decrypt2.twofa_enabled },
      //               });
      //             })
      //           );
      //         }
      //         return of(event);
      //       })
      //     );
      //   })
      // );
      const clonedReq = req.clone({
        body: extraPayload,
      });
      return next.handle(clonedReq).pipe(
        mergeMap((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            const responseBody = event.body;

            if (responseBody?.salt) {
              this.apiService.setCredsLogin(responseBody.salt);
            }

            return of(
              event.clone({
                // body: {
                //   verified: responseBody?.verified,
                //   twofa_enabled: responseBody?.twofa_enabled,
                // },
                body: responseBody,
              })
            );
          }

          return of(event);
        })
      );
    }
    return next.handle(req).pipe(
      tap((event: HttpEvent<unknown>) => {
        if (
          event instanceof HttpResponse &&
          typeof event.body === 'object' &&
          event.body !== null &&
          'message' in event.body &&
          this.endpoints_all.some(endpoint => event.url?.endsWith(endpoint))
        ) {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: (event.body as { message: string }).message, closable: false });
        }
      }),
      catchError((error: HttpEvent<unknown>) => {
        if (error instanceof HttpResponse && typeof error.body === 'object' && error.body !== null && 'message' in error.body) {
          this.messageService.add({ severity: 'error', summary: 'error', detail: (error.body as { message: string }).message, closable: false });
          if (error.status == 0 || error.status === 401) {
            localStorage.removeItem('auth_token');
            this.router.navigate(['/login']);
          }
        }
        return throwError(() => error);
      })
    );
  }
}

